import { SyntheticEvent } from "react";

export interface ISyntheticEvent extends SyntheticEvent {
  target: EventTarget;
  currentTarget: HTMLElement;
}
